import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

// Sequenced MOUNT reveal for hero content (eyebrow → h1 → lead → CTA). Runs once
// on load — not on scroll, since heroes are already in view. Staggers the direct
// children of the wrapper. SEO/a11y-safe: no-ops during the react-snap prerender
// and for reduced-motion users, so content is always present and visible.
export default function HeroReveal({ children, as: Tag = 'div', y = 20, className = '' }) {
  const ref = useRef(null);

  useGSAP(
    () => {
      const isPrerender = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
      const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (isPrerender || reduce || !ref.current) return;

      gsap.from(ref.current.children, {
        opacity: 0,
        y,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.12,
        delay: 0.15,
      });
    },
    { scope: ref }
  );

  return (
    <Tag ref={ref} className={className}>
      {children}
    </Tag>
  );
}
